<template>
  <nuttrema-layout-form-standard :edit="edit" :theme="theme" :saveError="InvitationDetails.saveError">
    <template slot="center">
      <el-form
        :model="formData"
        :rules="rules"
        :label-position="labelPosition"
        ref="meal-main-details"
        label-width="20em">

        <section>
          <h4 class="section-title">{{ $t('label.invite_for') }}</h4>
          <div class="section-items">

            <el-form-item :label="$t('label.first_name')" prop="first_name">
              <el-col :span="12">
                <el-input v-model="formData.first_name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.last_name')" prop="last_name">
              <el-col :span="16">
                <el-input v-model="formData.last_name" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.custom_message')" prop="custom_message">
              <el-col :span="24">
                <el-input
                  type="textarea"
                  v-model="formData.custom_message"
                  :autosize="{ minRows: 3, maxRows: 10 }"
                  :disabled="!edit">
                </el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.register_with_role') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.roles')">
              <el-col class="el-col--min-25em" :span="24">
                <el-select
                  v-model="formData.roles_id"
                  multiple
                  class="w-100"
                  placeholder="Select">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </div>
        </section>
      </el-form>
    </template>

    <template slot="footer">
      <nav class="level">
        <div class="level-left">
          <el-button type="primary" size="small" @click="submitForm('meal-main-details')">{{ $t('label.send_invite') }}</el-button>
        </div>
        <div class="level-right">
          <el-button
             type="text"
             size="small"
            @click="cancelChanges('meal-main-details')">
            {{ $t('label.cancel') }}
          </el-button>
        </div>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { pick, assign, isNil, last, omitBy } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';

import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';

export default {
  name: 'form-stuff-to-eat-main-details',
  props: {
    id: {
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    InvitationDetails: {
      type: Object,
      required: false,
    },
    Roles: {
      required: false,
      default: null,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaGroupAndSort,
    StuffToEatInfoSmallCard,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      options: [
        {
          value: 'Option1',
          label: 'Option1',
        },
        {
          value: 'Option2',
          label: 'Option2',
        },
        {
          value: 'Option3',
          label: 'Option3',
        },
        {
          value: 'Option4',
          label: 'Option4',
        },
        {
          value: 'Option5',
          label: 'Option5',
        },
      ],
      formData: {
        first_name: null,
        last_name: null,
        email: null,
        custom_message: null,
        roles_id: [],
      },
      originalData: {},
      rules: {
        name: [
          { required: true, message: 'Please input name', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const payload = this.getData();
          this.$emit('submit', this.toJSON(payload));
        }
        return valid;
      });
    },
    cancelChanges(formName) {
      this.edit = false;
      this.formData = assign({}, this.originalData);
      this.$nextTick(() => {
        this.$refs[formName].validate();
      });
    },
    handleDeleteEvent() {
      this.$emit('delete');
    },
    toJSON(data) {
      return JSON.parse(JSON.stringify(data));
    },
    mapData() {
      if (this.StuffToEatDetails) {
        this.formData = pick(this.StuffToEatDetails.data, [
          'name', 'description', 'entity_type_category_id',
        ]);
      }
      this.originalData = assign({}, this.formData);
    },
    getData() {
      const data = pick(this.formData, [
        'name', 'description',
      ]);
      data.entity_type_category_id = last(this.formData.entity_type_category_id) || '';
      return omitBy(data, isNil);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/my-team/invitation/form-team-member-invitation.vue